// deps
import React, { ReactElement, memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import { Parent, NewTag as StyledNewTag } from "./styles/NewTag.styled";

interface NewTagProps {
    title?: string;
    skipShimmer?: boolean;
}

const TITLE = "NEW";

const NewTag = (props: NewTagProps): ReactElement => {
    const { skipShimmer = false } = props;
    const title = props.title ?? TITLE;

    return (
        <Parent>
            <StyledNewTag $skipShimmer={skipShimmer}>
                <Text variant="V2.overline.neutral.black" color="background_Primary">
                    {title}
                </Text>
            </StyledNewTag>
        </Parent>
    );
};

export default memo(NewTag);
